
    <mat-grid-list [cols]="headerNumberList.length">
      <mat-grid-tile class="header" *ngFor="let header of headerNumberList" > 
          
           <div > <span>{{header.name}}</span> </div></mat-grid-tile>
      </mat-grid-list>
<mat-grid-list [cols]="cols"  [rowHeight]="rowHeight"  >
    <div>
      <mat-grid-tile *ngFor="let num of gridNumbersList.ToArray()" (mouseover)="mouseOver(num,$event)"
       (mousedown)="mouseDown(num,$event)"
        class="{{num.state}} normal mat-grid-tile">
        <div class="unselectable-text">
          <div>
            <span>{{num.name}}</span>
          </div>


        </div>
      </mat-grid-tile>
    </div>
  </mat-grid-list>